import { useEffect, useState } from 'react';
import { bookPageService } from '@/api/services';
import { usePublicCatalogData } from '@/components/PublicCatalogData';

export const useBookPage = (sectionKey = null) => {
  const catalog = usePublicCatalogData();
  const contextSections = catalog?.bookSections != null ? catalog.bookSections : null;
  const contextSection = sectionKey && Array.isArray(contextSections)
    ? (contextSections.find((item) => String(item?.section_key || '') === String(sectionKey)) || null)
    : null;
  const hasContext = contextSections != null;
  const [sections, setSections] = useState(contextSections || []);
  const [section, setSection] = useState(hasContext ? contextSection : null);
  const [loading, setLoading] = useState(!hasContext);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasContext) {
      setSections(contextSections || []);
      setSection(contextSection);
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        if (sectionKey) {
          setSection(null);
          // Resolve section from full payload to avoid noisy 404 logs
          // when an optional section key is not configured yet.
          const response = await bookPageService.getAllSections();
          const rows = Array.isArray(response.data?.data) ? response.data.data : [];
          const match = rows.find((item) => String(item?.section_key || '') === String(sectionKey));
          setSection(match || null);
        } else {
          setSections([]);
          const response = await bookPageService.getAllSections();
          if (response.data?.success) {
            setSections(response.data.data || []);
          }
        }
      } catch (err) {
        const status = Number(err?.response?.status || 0);
        if (status !== 404) {
          console.error('Error fetching book page data:', err);
          setError(err.message || 'Failed to load book page data');
        } else {
          setError(null);
        }
        if (sectionKey) {
          setSection(null);
        } else {
          setSections([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [sectionKey, hasContext, contextSections, contextSection]);

  return { sections, section, loading, error };
};

export default useBookPage;
